import { Divider, Heading, Stack } from '@chakra-ui/react';
import HorizontalLabeledValue from 'components/modules/labeledValue/HorizontalLabeledValue';
import dayjs from 'dayjs';
import { ReservationFormType } from 'features/reservations/types/ReservationType';
import { FC } from 'react';

type ReservationFormViewerProps = {
  headding: '予約内容の確認' | '予約内容';
  reservationForm: ReservationFormType;
};

/** 予約フォーム画面（ReservationCustomerForm）の入力内容を表示するコンポーネント */
const ReservationFormViewer: FC<ReservationFormViewerProps> = ({
  headding,
  reservationForm
}) => {
  return (
    <Stack w="100%" gap="1.5rem">
      <Heading fontSize="xl" fontWeight="bold">
        {headding}
      </Heading>

      <Stack>
        <HorizontalLabeledValue
          label="受取店舗"
          value={reservationForm.store.name}
        />
        <Divider />
        <HorizontalLabeledValue
          label="受取日"
          value={dayjs(reservationForm.receipt_at).format('YYYY/MM/DD (ddd)')}
        />
        <Divider />
        <HorizontalLabeledValue
          label="受取時間"
          value={`${reservationForm.receipt_hour_width_start_at}〜${reservationForm.receipt_hour_width_end_at}`}
        />
        {reservationForm.card_number && (
          <>
            <Divider />
            <HorizontalLabeledValue
              label="会員番号"
              value={reservationForm.card_number}
            />
          </>
        )}
        {reservationForm.tel_number && (
          <>
            <Divider />
            <HorizontalLabeledValue
              label="電話番号"
              value={reservationForm.tel_number}
            />
          </>
        )}
        {reservationForm.staff_comment && (
          <>
            <Divider />
            <HorizontalLabeledValue
              label="受付スタッフ記入欄"
              value={reservationForm.staff_comment}
            />
          </>
        )}
        {reservationForm?.option_1_answer && (
          <>
            <Divider />
            <HorizontalLabeledValue
              label={reservationForm.campaign_option_1_label || '任意項目1'}
              value={reservationForm.option_1_answer}
            />
          </>
        )}
        {reservationForm?.option_2_answer && (
          <>
            <Divider />
            <HorizontalLabeledValue
              label={reservationForm.campaign_option_2_label || '任意項目2'}
              value={reservationForm.option_2_answer}
            />
          </>
        )}
        {reservationForm?.option_3_answer && (
          <>
            <Divider />
            <HorizontalLabeledValue
              label={reservationForm.campaign_option_3_label || '任意項目3'}
              value={reservationForm.option_3_answer}
            />
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default ReservationFormViewer;
